import { home } from '@/lang/nl/pages/home.ts'
import { pricing } from '@/lang/nl/pages/pricing.ts'

import { manager } from '@/lang/nl/pages/products/manager.ts'
import { page } from '@/lang/nl/pages/products/page.ts'
import { pos } from '@/lang/nl/pages/products/pos.ts'
import { qr } from '@/lang/nl/pages/products/qr.ts'
import { webshop } from '@/lang/nl/pages/products/webshop.ts'

import { lunchroom } from '@/lang/nl/pages/cases/lunchroom.ts'
import { cafetaria } from '@/lang/nl/pages/cases/cafetaria.ts'
import { grillroom } from '@/lang/nl/pages/cases/grillroom.ts'
import { sushi } from '@/lang/nl/pages/cases/sushi.ts'
import { italian } from '@/lang/nl/pages/cases/italian.ts'

import { support } from '@/lang/nl/pages/info/support.ts'
import { faq } from '@/lang/nl/pages/info/faq.ts'
import { downloads } from '@/lang/nl/pages/info/downloads.ts'
import { integrations } from '@/lang/nl/pages/info/integrations.ts'

export const pages = {
  home,
  products: {
    manager,
    page,
    pos,
    qr,
    webshop
  },
  pricing,
  cases: {
    lunchroom,
    cafetaria,
    grillroom,
    sushi,
    italian
  },
  info: {
    support,
    faq,
    downloads,
    integrations
  },
}